'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp2;

var _reactRedux = require('react-redux');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Login: {
    displayName: 'Login'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/containers/Login/Login.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import Helmet from 'react-helmet';


var Login = _wrapComponent('Login')((_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}, authActions), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Login, _Component);

  function Login() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Login);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Login.__proto__ || (0, _getPrototypeOf2.default)(Login)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (event) {
      event.preventDefault();
      var input = _this.refs.username;
      _this.props.login(input.value);
      input.value = '';
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Login, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          logout = _props.logout;

      var styles = require('./Login.scss');
      return _react3.default.createElement(
        'div',
        { className: styles.loginPage + ' container' },
        _react3.default.createElement(
          'h1',
          null,
          'Login'
        ),
        !user && _react3.default.createElement(
          'div',
          null,
          _react3.default.createElement(
            'form',
            { className: 'login-form form-inline', onSubmit: this.handleSubmit },
            _react3.default.createElement(
              'div',
              { className: 'form-group' },
              _react3.default.createElement('input', { type: 'text', ref: 'username', placeholder: 'Enter a username', className: 'form-control' })
            ),
            _react3.default.createElement(
              'button',
              { className: 'btn btn-success', onClick: this.handleSubmit },
              _react3.default.createElement('i', { className: 'fa fa-sign-in' }),
              ' ',
              'Log In'
            )
          ),
          _react3.default.createElement(
            'p',
            null,
            'This will "log you in" as this user, storing the username in the session of the API server.'
          )
        ),
        user && _react3.default.createElement(
          'div',
          null,
          _react3.default.createElement(
            'p',
            null,
            'You are currently logged in as ',
            user.name,
            '.'
          ),
          _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(
              'button',
              { className: 'btn btn-danger', onClick: logout },
              _react3.default.createElement('i', { className: 'fa fa-sign-out' }),
              ' ',
              'Log Out'
            )
          )
        )
      );
    }
  }]);
  return Login;
}(_react2.Component), _class2.propTypes = {
  user: _react2.PropTypes.object,
  login: _react2.PropTypes.func,
  logout: _react2.PropTypes.func
}, _temp2)) || _class));

exports.default = Login;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Login/Login.js
// module id = 1209
// module chunks = 0